
import isEqual from 'lodash/isEqual'

export function pullAsyncObjectDifferences ({
  getObject = async () => ({}),
  onChange = () => {},
  intervalDuration = 30000,
} = {}, obj = {}) {
  const currentObj = { ...obj }

  const intervalId = setInterval(() => {
    getObject()
      .then(obj => {
        if (!obj || isEqual(obj, currentObj)) return

        Object.keys(obj).forEach(key => { currentObj[key] = obj[key] })
        onChange(obj)
      }, error => {
        // eslint-disable-next-line no-console
        console.error(error)
      })
  }, intervalDuration)

  return {
    stop () {
      clearInterval(intervalId)
    },
  }
}
